import { useBoolean, useEffectOnce } from 'usehooks-ts';

import Text from './Text';

interface CriteriaTextareaProps
  extends React.HTMLAttributes<HTMLTextAreaElement> {
  onChange: (arg: React.ChangeEvent<HTMLTextAreaElement>) => void;
  displayLabel: string;
  className?: string;
  value?: string;
}
const CriteriaTextarea = ({
  displayLabel,
  onChange,
  className,
  value,
  ...props
}: CriteriaTextareaProps) => {
  const { value: hasValue, setValue: setHasValue } = useBoolean();
  const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(event);
  };
  useEffectOnce(() => {
    setHasValue(value !== '');
  });
  return (
    <div className="relative w-full">
      <textarea
        {...props}
        onFocus={() => setHasValue(true)}
        onBlur={(event) => setHasValue(event.target.value !== '')}
        onChange={handleOnChange}
        value={value}
        className={`textarea leading-tight textarea-bordered w-full rounded-md 
      focus:outline-none placeholder:text-gray-600 placeholder:font-light placeholder:opacity-0 focus:placeholder:opacity-100 
        placeholder:transition-opacity placeholder:text-sm text-primary text-base lg:text-lg  pt-8 min-h-[190px]
      border-gray-300 pl-4 font-bold  ${className} ${hasValue && 'bg-gray-50'}`}
        placeholder="Écrire ici"
      ></textarea>
      {/* Layer on top of the select */}
      <div
        className={`absolute inset-0 flex gap-2 pl-[1.1rem] pointer-events-none items-start`}
      >
        {/* Label */}
        <Text
          as="div"
          text={displayLabel}
          className={`text-xs md:text-sm text-gray-600 transition-all mt-6 -ml-1  p-1 rounded-md ${
            hasValue ? 'transfrom -translate-y-3 !text-2xs font-light' : ''
          }`}
        />
      </div>
    </div>
  );
};

export default CriteriaTextarea;
